import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useState, useEffect } from "react";
import lampaImage from './lampa.png';
import { useNavigate } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import exoikonomoImg from './eksoi.jpg';
import pistopImg from './pistop.jpg';
import hlektImg from './hlekt.jpg';
import arthroImg from './arhtroImg.jpg';
import technikosImg from './technikosImg.jpg';
import poleodomiaImg from './poleodomiaImg.jpg';
import energiakoImg1 from './energiakoImg1.webp';
import energiakoImg2 from './energiakoImg2.webp';
import thermoImg from './thermoImg.jpg';
import eedmkImg from './eedmkImg.jpg';
import autoImg from './autoImg.png';
import thermoprosopsiImg from './thermoprosopsiImg.jpg';

interface Dot {
  id: number;
  left: number;
  top: number;
  vx: number;
  vy: number;
}

function AnimatedDots() {
  const [dots, setDots] = useState<Dot[]>([]);
  
  useEffect(() => {
    // Initialize dots
    const dotsArray: Dot[] = Array.from({ length: 30 }, (_, i) => ({
      id: i,
      left: Math.random() * 100,
      top: Math.random() * 100,
      vx: (Math.random() - 0.5) * 0.5,
      vy: (Math.random() - 0.5) * 0.5,
    }));
    setDots(dotsArray);

    // Animation loop
    const interval = setInterval(() => {
      setDots(prevDots =>
        prevDots.map(dot => {
          let newLeft = dot.left + dot.vx;
          let newTop = dot.top + dot.vy;
          let newVx = dot.vx;
          let newVy = dot.vy;

          // Bounce off edges
          if (newLeft < 0 || newLeft > 100) {
            newVx = -newVx;
            newLeft = Math.max(0, Math.min(100, newLeft));
          }
          if (newTop < 0 || newTop > 100) {
            newVy = -newVy;
            newTop = Math.max(0, Math.min(100, newTop));
          }

          return {
            ...dot,
            left: newLeft,
            top: newTop,
            vx: newVx,
            vy: newVy,
          };
        })
      );
    }, 50);

    return () => clearInterval(interval);
  }, []);

  return (
    <div style={{ position: "absolute", width: "100%", height: "100%", overflow: "hidden" }}>
      {dots.map(dot => (
        <div
          key={dot.id}
          style={{
            position: "absolute",
            left: `${dot.left}%`,
            top: `${dot.top}%`,
            width: 1.25,
            height: 1.25,
            borderRadius: "50%",
            background: "green",
            animation: `infinite`,
            animationDelay: `${Math.random() * 4}s`,
            pointerEvents: "none",
            boxShadow: "0 0 3px rgba(0, 255, 0, 0.6)",
          }}
        />
      ))}
    </div>
  );
}

function Navbar() {
  return (
    <nav style={{ 
      padding: 12, 
      background: "white", 
      display: "flex", 
      gap: 12, 
      justifyContent: "center", 
      alignItems: "center",
      position: "relative",
      overflow: "hidden",
      height: 100
    }}>
      <AnimatedDots />
      <div style={{ display: "flex", alignItems: "center", gap: 8, zIndex: 1 }}>
        <img
          src={lampaImage}
          alt="MiEnergy_Logo"
          style={{ width: 350, height: 233, borderRadius: 6 }}
        />
      </div>
    </nav>
  );
}

function Card({
  title,
  text,
  onClick,
  style,
  image
}: {
  title: string;
  text: string;
  onClick: () => void;
  style?: React.CSSProperties;
  image?: string;
}) {
  return (
    <div
      onClick={onClick}
      style={{
        padding: 16,
        borderRadius: 12,
        background: "#f5f5f5",
        boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
        cursor: "pointer",
        textAlign: "center",
        fontFamily: "Trebuchet MS, Helvetica, sans-serif",
        fontWeight: "bold",
        marginTop: 10,
        ...style,
      }}
    >
      {image && (
        <img
          src={image}
          alt={title}
          style={{ width: "100%", borderRadius: 8, marginBottom: 12 }}
        />
      )}
      <h3>{title}</h3>
      <p>{text}</p>
    </div>
  );
}

// Ripple effect component
function RippleEffect() {
  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      const ripple = document.createElement("span");

      ripple.style.position = "fixed";
      ripple.style.left = e.clientX + "px";
      ripple.style.top = e.clientY + "px";
      ripple.style.width = "5px";
      ripple.style.height = "5px";
      ripple.style.borderRadius = "50%";
      ripple.style.background = "green";
      ripple.style.transform = "translate(-50%, -50%) scale(0)";
      ripple.style.pointerEvents = "none";
      ripple.style.animation = "ripple 0.6s ease-out";

      document.body.appendChild(ripple);

      setTimeout(() => {
        ripple.remove();
      }, 600);
    };

    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, []);

  return null;
}


function Home() {
  const navigate = useNavigate();
  const cardColor = "#F7F7F7";

  return (
    <div style={{ padding: 20 }}>
      <div
        style={{
          display: "grid",
          gap: 16,
          gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
          marginTop: 20,
        }}
      >
        <Card 
          title="Πιστοποιητικό Ενεργειακής Απόδοσης" 
          text="Πότε απαιτείται?" 
          onClick={() => navigate("/energiako")}
          image={pistopImg}
          style={{ background: cardColor }}
        />
        <Card 
          title="Πιστοποιητικό Ηλεκτρολόγου" 
          text="Πότε το ζητάει η ΔΕΔΔΗΕ?" 
          onClick={() => navigate("/hlektrologos")}
          image={hlektImg}
          style={{ background: cardColor }}
        />
        <Card 
          title="Πρόγραμμα «Εξοικονομώ»" 
          text="Μάθετε αν το δικαιούστε και τι αφορά" 
          onClick={() => navigate("/eksikonomo")}
          image={exoikonomoImg}
          style={{ background: cardColor }}
        />
      </div>

      <div
        style={{
          display: "grid",
          gap: 16,
          gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
          marginTop: 20,
        }}
      >
        <Card 
          title="Πολεοδομικός Φάκελος" 
          text="Τί περιλαμβάνει? Πότε χρειάζεται?" 
          onClick={() => navigate("/poleodomia")}
          image={poleodomiaImg}
          style={{ background: cardColor }}
        />
        <Card 
          title="Άρθρο 30 Ν.4495/2017" 
          text="Τί λέει ο νόμος?" 
          onClick={() => navigate("/arthro")}
          image={arthroImg}
          style={{ background: cardColor }}
        />
        <Card 
          title="Μελέτη Θέρμανσης" 
          text="Μάθετε τα οφέλη" 
          onClick={() => navigate("/thermansi")}
          image={thermoImg}
          style={{ background: cardColor }}
        />
      </div>

        <div
        style={{
          display: "grid",
          gap: 16,
          gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
          marginTop: 20,
        }}
      >
        <Card 
          title="Έγκριση εργασιών δόμησης μικρής κλίμακας (ΕΕΔΜΚ)" 
          text="Μάθετε τι είναι και πότε χρειάζεται?" 
          onClick={() => navigate("/eedmk")}
          image={eedmkImg}
          style={{ background: cardColor }}
        />
        <Card 
          title="Τεχνικός Ασφαλείας" 
          text="Πότε χρειάζεται?" 
          onClick={() => navigate("/technikos")}
          image={technikosImg}
          style={{ background: cardColor }}
        />
        <div />
      </div>
    </div>
  );
}

function Eksikonomo() {
  const navigate = useNavigate();
  return (
    <section className="Eksikonomo" style={{
      maxWidth: 700,
      margin: '2rem auto',
      padding: '1.5rem',
      background: '#fff',
      borderRadius: 12,
      boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
    }}>
      <button
        onClick={() => navigate(-1)}
        style={{ background: 'none', border: 'none', fontSize: 36, cursor: 'pointer', marginBottom: 12 }}
        aria-label="Back"
      >
        ←
      </button>
      <h2 style={{ fontSize: '2rem', marginBottom: '1rem' }}>Πρόγραμμα «Εξοικονομώ»</h2>
      <p style={{ fontSize: '1.1rem', lineHeight: 1.7, marginBottom: '1.2rem' }}>
        Το πρόγραμμα «Εξοικονομώ» επιδοτεί παρεμβάσεις ενεργειακής αναβάθμισης κατοικιών με στόχο τη μείωση της κατανάλωσης ενέργειας και του κόστους θέρμανσης και ψύξης. Ο σχεδιασμός του Προγράμματος λαμβάνει υπόψη την ολοκληρωμένη προσέγγιση παρεμβάσεων εξοικονόμησης ενέργειας στον οικιακό κτηριακό τομέα και έχει ως στόχο:
      </p>
      <ul>
        <li>τη μείωση των ενεργειακών αναγκών των κτηρίων και των εκπομπών ρύπων που συμβάλλουν στην επιδείνωση του φαινομένου του θερμοκηπίου</li>
        <li>την εξοικονόμηση κόστους για τους πολίτες, τη βελτίωση των καθημερινών συνθηκών διαβίωσης και άνεσης καθώς και, της ασφάλειας και της υγείας των πολιτών κατά τη χρήση των κτηρίων αυτών</li>
        <li>την επίτευξη καθαρότερου περιβάλλοντος</li>
      </ul>
      <p style={{ fontSize: '1.1rem', lineHeight: 1.7, marginBottom: '1.2rem' }}>
        Το Πρόγραμμα συνίσταται στην παροχή κινήτρων για παρεμβάσεις εξοικονόμησης ενέργειας στον οικιακό κτηριακό τομέα, με στόχο τη μείωση των ενεργειακών αναγκών και της κατανάλωσης συμβατικών καυσίμων, στο πλαίσιο της μετάβασης σε ένα «Ενεργειακά Αποδοτικό Σπίτι».
      </p>
      <p style={{ fontSize: '1.1rem', lineHeight: 1.7, marginBottom: '1.2rem' }}>
        Το Πρόγραμμα αφορά σε κτήρια που βρίσκονται  σε ενεργειακή κατηγορία χαμηλότερη ή ίση της Γ (σύμφωνα με το Πρώτο Πιστοποιητικό Ενεργειακής Απόδοσης - Α’ Π.Ε.Α.), διαθέτουν οικοδομική άδεια ή άλλο νομιμοποιητικό έγγραφο, χρησιμοποιούνται ως κύρια κατοικία και των οποίων οι ιδιοκτήτες πληρούν συγκεκριμένα εισοδηματικά κριτήρια.
      </p>
      <h3 style={{ fontSize: '1.15rem', marginBottom: '1rem' }}>Οι επιλέξιμες παρεμβάσεις για την ανακαίνιση του σπιτιού σας</h3>
      <p style={{ fontSize: '1.1rem', lineHeight: 1.7, marginBottom: '1.2rem' }}>
        Εφόσον κάποιος πληροί της προϋποθέσεις και υπαχθεί στο πρόγραμμα «Εξοικονομώ», έχοντας προτείνει τις ενεργειακές παρεμβάσεις στις οποίες θα προβεί και αφού έχει υπολογιστεί το μέγιστο ποσοστό επιδότησης που δικαιούται, μπορεί να προχωρήσει η υλοποίηση των παρεμβάσεων. Αυτές χωρίζονται σε 5 κατηγορίες:
      </p>
      <ul>
        <li>Α. Κουφώματα/Συστήματα Σκίασης/Αερισμός</li>
        <li>Β. Εξωτερική ή εσωτερική θερμομόνωση τοιχοποιίας/στέγης/πυλωτής</li>
        <li>Γ. Συστήματα Θέρμανσης/Ψύξης εσωτερικού χώρου</li>
        <li>Δ. Συστήματα Παροχής Ζεστού Νερού Χρήσης</li>
        <li>Ε. Συσκευές διαχείρισης ενέργειας (smart home) </li>
      </ul>
      <h3 style={{ fontSize: '1.15rem', marginBottom: '1rem' }}>Επιδότηση</h3>
      <ul>
        <li>Κυμαίνεται περίπου από 40% έως 90% (εξαρτάται από κάθε πρόγραμμα και τη διακύμανσή του)</li>
        <li>Εξαρτάται κυρίως από το εισόδημα και την κοινωνική κατηγορία (π.χ. πολύτεκνοι, μονογονεϊκές οικογένειες, ΑμεΑ)</li>
        <li>Δεν εξαρτάται από την παλαιότητα, την κατάσταση του κτιρίου ή το πλήθος των εργασιών</li>
      </ul>
      <h3 style={{ fontSize: '1.15rem', marginBottom: '1rem' }}>Δικαιολογητικά</h3>
      <p style={{ fontSize: '1.1rem', lineHeight: 1.7, marginBottom: '1.2rem' }}>
        Τα δικαιολογητικά που θα ζητηθούν καθορίζονται από τον οδηγό του κάθε προγράμματος. Αυτά που αναγράφουμε παρακάτω έχει παρατηρηθεί ότι ζητούνται σχεδόν πάντα. Σημειώνεται ότι ενδέχεται να ζητηθούν και επιπλέον.
      </p>
      <ul>
        <li>Συμβόλαιο ιδιοκτησίας</li>
        <li>E9</li>
        <li>Εκκαθαριστικό σημείωμα</li>
        <li>Λογαριασμός ρεύματος</li>
        <li>Τακτοποιήσεις αυθαιρέτων</li>
        <li>Ηλεκτρονική Ταυτότητα Κτιρίου (όπου υπάρχει)</li>
        <li>Πολεοδομικός φάκελος (σε επόμενο στάδιο πλήρης)</li>
        <li>Στέλεχος οικοδομικής άδειας (αρχικά)</li>
      </ul>
      <p style={{ fontSize: '1.1rem', lineHeight: 1.7, marginBottom: '1.2rem' }}>
        👉 Κατά την αρχική αίτηση απαιτείται συνήθως μόνο το στέλεχος της οικοδομικής άδειας, ενώ αργότερα θα ζητηθεί και ο πλήρης πολεοδομικός φάκελος με τα σχέδια.
      </p>
      <h3 style={{ fontSize: '1.15rem', marginBottom: '1rem' }}>Προϋποθέσεις</h3>
      <ul>
        <li>Το ακίνητο πρέπει να είναι νόμιμο, χωρίς αυθαίρετες κατασκευές. Μικρές αυθαιρεσίες έως 7 τ.μ. μπορούν να τακτοποιηθούν και κατά τη διάρκεια του προγράμματος, ενώ μεγαλύτερες πρέπει να τακτοποιηθούν πριν την ένταξη</li>
        <li>Να είναι ηλεκτροδοτούμενο</li>
        <li>Σε ορισμένα προγράμματα να χρησιμοποιείται ως κύρια κατοικία, αν δεν είναι πρόσφατη απόκτηση</li>
      </ul>
      <h3 style={{ fontSize: '1.15rem', marginBottom: '1rem' }}>Τελική Σύσταση</h3>
      <p style={{ fontSize: '1.1rem', lineHeight: 1.7, marginBottom: '1.2rem' }}>
        👉 Αν κάποιος ενδιαφέρεται να ενταχθεί στο πρόγραμμα, καλό είναι να κάνει έγκαιρη προετοιμασία όλων των δικαιολογητικών, ώστε να αποφευχθούν καθυστερήσεις κατά την αίτηση και την ένταξη στο «Εξοικονομώ»
      </p>
      <style>{`
        @media (max-width: 600px) {
          .Eksikonomo {
            padding: 1rem !important;
            margin: 1rem !important;
          }
          .Eksikonomo h2 {
            font-size: 1.4rem !important;
          }
          .Eksikonomo p {
            font-size: 1rem !important;
          }
        }
      `}</style>
    </section>
  );
}

function Energiako() {
  const navigate = useNavigate();

  return <section className="Eksikonomo" style={{
      maxWidth: 700,
      margin: '2rem auto',
      padding: '1.5rem',
      background: '#fff',
      borderRadius: 12,
      boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
    }}>
      <button 
        onClick={() => navigate(-1)}
        style={{ background: "none", border: "none", fontSize: 36, cursor: "pointer" }}
      >
        ←
      </button>
      <h2 style={{ fontSize: '2rem', marginBottom: '1rem' }}>Πιστοποιητικό Ενεργειακής Απόδοσης</h2>
      <p style={{ fontSize: '1.1rem', lineHeight: 1.7, marginBottom: '1.2rem' }}>
        Σύμφωνα με τον Κανονισμό Ενεργειακής Απόδοσης Κτιρίων Κ.Εν.Α.Κ. (<a href="https://www.kenak.gr/files/NOMIKO_PLAISIO/14.pdf" target="_blank" rel="noopener noreferrer">Άρθρο 14</a>) το Πιστοποιητικό Ενεργειακής Απόδοσης Π.Ε.Α. κτιρίων:
      </p>
      <ul>
        <li>Απεικονίζει την ενεργειακή κατάταξη του κτιρίου.</li>
        <li>Στο ΠΕΑ αναφέρονται, μεταξύ άλλων, τα γενικά στοιχεία του κτιρίου, η υπολογιζόμενη ετήσια συνολική κατανάλωση πρωτογενούς ενέργειας του κτιρίου αναφοράς και του εξεταζόμενου κτιρίου, η ετήσια κατανάλωση ενέργειας ανά πηγή ενέργειας και τελική χρήση, η πραγματική ετήσια συνολική τελική κατανάλωση ενέργειας, οι υπολογιζόμενες και πραγματικές ετήσιες εκπομπές διοξειδίου του άνθρακα, καθώς και συστάσεις για τη βελτίωση της ενεργειακής απόδοσης του κτιρίου.</li>
        <li>Κάθε συμβολαιογράφος για την κατάρτιση πράξεως αγοραπωλησίας ακινήτου υποχρεούται να μνημονεύσει στο συμβόλαιο τον αριθμό πρωτοκόλλου του ΠΕΑ και να επισυνάψει σε αυτό επίσημο αντίγραφο του ΠΕΑ.</li>
      </ul>
      <p style={{ fontSize: '1.1rem', lineHeight: 1.7, marginBottom: '1.2rem' }}>
        Σε κάθε μίσθωση ακινήτου, ο αριθμός πρωτοκόλλου του ΠΕΑ πρέπει να συμπληρώνεται στα σχετικά πεδία των ηλεκτρονικών δηλώσεων μίσθωσης που υποβάλλονται μετά την 09/11/2015 βάσει του άρθρου 58, παρ. 3, Ν.4342 /2015 <a href="https://www.kenak.gr/files/NOMIKO_PLAISIO/FEK_143A_2015_arthro58_3_kenak.pdf" target="_blank" rel="noopener noreferrer">άρθρου 58, παρ. 3, Ν.4342 /2015</a>.
      </p>
      <h3 style={{ fontSize: '1.15rem', marginBottom: '1rem' }}>Πότε απαιτείται</h3>
      <ul>
        <li>Σε περίπτωση αγοράς – πώλησης κτηρίου.</li>
        <li>Σε περίπτωση νέων συμβάσεων μίσθωσης (και όχι ανανέωση υφισταμένων συμβάσεων μίσθωσης).</li>
        <li>Μετά την ολοκλήρωση κατασκευής νέου κτιρίου ή κτιριακής μονάδας</li>
        <li>Μετά την ολοκλήρωση ριζικής ανακαίνισης κτιρίου ή κτιριακής μονάδας</li>
        <li>Για κτίρια συνολικής επιφάνειας άνω των διακοσίων πενήντα (250) τετραγωνικών μέτρων τα οποία χρησιμοποιούνται από υπηρεσίες του δημόσιου και ευρύτερου δημόσιου τομέα και τα οποία επισκέπτεται συχνά το κοινό.</li>
      </ul>
      <p style={{ fontSize: '1.1rem', lineHeight: 1.7, marginBottom: '1.2rem' }}>
        👉 Η χρονική ισχύς ενός Πιστοποιητικού Ενεργειακής Απόδοσης είναι 10 (δέκα) έτη, ανεξάρτητα από το αν αλλάξει ιδιοκτήτης ή ενοικιαστής. Η μόνη περίπτωση που θα απαιτειθεί να εκδοθεί νέο Ενεργειακό Πιστοποιητικό πριν τα 10 έτη είναι αν ανακαινιστεί ριζικά, δηλαδή σύμφωνα με την παράγραφο 12 του άρθρου 2 του Ν. 4122/2013: «Ριζική ανακαίνιση κτιρίου ή κτιριακής μονάδας (ανακαίνιση μεγάλης κλίμακας)»:
      </p>
      <p style={{ fontSize: '1.1rem', lineHeight: 1.7, marginBottom: '1.2rem' }}>
        Η ανακαίνιση κατά την οποία:
      </p>
      <ul>
        <li>η συνολική δαπάνη της ανακαίνισης που αφορά το κέλυφος του κτιρίου ή της κτιριακής μονάδας ή τα τεχνικά συστήματά τους υπερβαίνει το είκοσι πέντε τοις εκατό (25%) της τρέχουσας αξίας του κτιρίου ή της κτιριακής μονάδας, βάσει του ελαχίστου κόστους οικοδόμησης, εξαιρουμένης της αξίας του οικοπέδου επί του οποίου έχει κατασκευαστεί το κτίριο, ή</li>
        <li>υφίσταται ανακαίνιση άνω του είκοσι πέντε τοις εκατό (25%) της επιφανείας του κελύφους του κτιρίου ή της κτιριακής μονάδας.</li>
      </ul>

      <h2 style={{ fontSize: '2rem', marginBottom: '1rem' }}>Επαλήθευση</h2>
      <p style={{ fontSize: '1.1rem', lineHeight: 1.7, marginBottom: '1.2rem' }}>
        Η εγκυρότητα του ΠΕΑ μπορεί να επαληθευθεί βάσει του αριθμού πρωτοκόλλου – Α.Π. και του δεκαεξαψήφιου αριθμού ασφαλείας – Α.Α.
      </p>
      <img src={energiakoImg1} alt="energiakoImg1" style={{ display: "block", margin: "1.5rem auto", maxWidth: "100%" }} />
      <p style={{ fontSize: '1.1rem', lineHeight: 1.7, marginBottom: '1.2rem' }}>
        Αυτά τα στοιχεία μπορείτε να τα καταχωρήσετε στη σελίδα <a href="https://www.buildingcert.gr/" target="_blank" rel="noopener noreferrer">https://www.buildingcert.gr/</a> στο σχετικό πεδίο “Έλεγχος Εγκυρότητας ΠΕΑ:” του Αρχείου Ενεργειακών Επιθεωρήσεων
      </p>
      <img src={energiakoImg2} alt="energiakoImg2" style={{ display: "block", margin: "1.5rem auto", maxWidth: "100%" }} />
      <p style={{ fontSize: '1.1rem', lineHeight: 1.7, marginBottom: '1.2rem' }}>
        👉 Προσοχή στη σωστή αντιγραφή των ψηφίων. Συχνά παρατηρείται να συγχέεται το Ο (όμικρον) με το 0 (μηδέν)!
      </p>
      <style>{`
        @media (max-width: 600px) {
          .Eksikonomo {
            padding: 1rem !important;
            margin: 1rem !important;
          }
          .Eksikonomo h2 {
            font-size: 1.4rem !important;
          }
          .Eksikonomo p {
            font-size: 1rem !important;
          }
        }
      `}</style>
    </section>;
}

function Hlektrologos() {
  const navigate = useNavigate();

  return <section className="Hlektrologos" style={{
      maxWidth: 700,
      margin: '2rem auto',
      padding: '1.5rem',
      background: '#fff',
      borderRadius: 12,
      boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
    }}>
      <button 
        onClick={() => navigate(-1)}
        style={{ background: "none", border: "none", fontSize: 36, cursor: "pointer" }}
      >
        ←
      </button>
      <h2 style={{ fontSize: '2rem', marginBottom: '1rem' }}>Πιστοποιητικό Ηλεκτρολόγου</h2>
      <p style={{ fontSize: '1.1rem', lineHeight: 1.7, marginBottom: '1.2rem' }}>
        Σκοπός του Πιστοποιητικού Ηλεκτρολόγου είναι ο έλεγχος της εγκατάστασης ως προς τις απαιτήσεις του προτύπου HD384 για τις σύγχρονες και νέες εγκαταστάσεις και ως προς τον Κανονισμό Εσωτερικών Ηλεκτρικών Εγκαταστάσεων (ΚΕΗΕ) για τις παλαιότερες εγκαταστάσεις. Πιστοποιητικό ηλεκτρολόγου ζητείται από το ΔΕΔΔΗΕ όταν:
      </p>
      <ul>
        <li>ο πελάτης ζητήσει αλλαγή ονόματος στο λογαριασμό του προμηθευτή (π.χ. της Δ.Ε.Η) και έχει λήξει το προηγούμενο πιστοποιητικό.</li>
        <li>ο πελάτης ζητήσει αλλαγή προμηθευτή (π.χ. να φύγει από τη ΔΕΗ) και έχει λήξει το προηγούμενο πιστοποιητικό.</li>
        <li>ο πελάτης ζητήσει οποιαδήποτε τροποποίηση στην παροχή του (π.χ. επαύξηση) και έχει λήξει το προηγούμενο πιστοποιητικό.</li>
        <li>ο πελάτης ζητήσει επανασύνδεση και έχει λήξει το προηγούμενο πιστοποιητικό.</li>
        <li>ηλεκτροδοτείται εργοταξιακή παροχή.</li>
        <li>ολοκληρώνεται κάθε νέα ηλεκτρική εγκατάσταση και πριν να τεθεί σε λειτουργία από τον χρήστη.</li>
        <li>ολοκληρώνεται η επέκταση ή η τροποποίηση κάποιας ηλεκτρολογικής εγκατάστασης.</li>
      </ul>
      <p style={{ fontSize: '1.1rem', lineHeight: 1.7, marginBottom: '1.2rem' }}>
        Σε κάθε περίπτωση μπορείτε να επικοινωνήσετε με το 11500 (ή στο 2106967500 από εξωτερικό) και να σας ενημερώσουν αν είναι σε ισχύ το προηγούμενο Πιστοποιητικού Ηλεκτρολόγου.
      </p>
      <p style={{ fontSize: '1.1rem', lineHeight: 1.7, marginBottom: '1.2rem' }}>
        ⚠️ Σε περίπτωση που η εγκατάσταση δεν ηλεκτροδοτείται (π.χ. έχει γίνει διακοπή ηλεκτροδότησης), θα πρέπει να εκδοθεί μια Μη Οριστικοποιημένη ΥΔΕ για να συνδεθεί το ρεύμα και στη συνέχεια θα πρέπει να εκδοθεί Οριστικοποιημένη ΥΔΕ εντός 45 ημερών από την ηλεκτροδότηση της εγκατάστασης. Φυσικά, αυτό συνεπάγεται τη διενέργεια δυο επισκέψεων στο ακίνητο καθώς ορισμένες μετρήσεις απαιτούν την ύπαρξη ενεργής παροχής ρεύματος.
      </p>
      <p style={{ fontSize: '1.1rem', lineHeight: 1.7, marginBottom: '1.2rem' }}>
        Επίσης, στη σελίδα <a href="https://apps.deddie.gr/LicensedElectricianCertification/main.html" target="_blank" rel="noopener noreferrer">Έλεγχος ΥΔΕ</a> μπορείτε να ελέγξετε αν έχει λήξει το Πιστοποιητικό Ηλεκτρολόγου για το σπίτι ή τον επαγγελματικό σας χώρο (γραφείο, κατάστημα κλπ) ώστε να μπορείτε να αλλάξετε το όνομα στο λογαριασμό του ηλεκτρικού ρεύματος ή να επανασυνδέσετε το ρεύμα ή να αλλάξετε πάροχο.
      </p>
      <p style={{ fontSize: '1.1rem', lineHeight: 1.7, marginBottom: '1.2rem' }}>
        Σε περίπτωση που μετά τον έλεγχο για πιστοποιητικά ΔΕΗ ο ηλεκτρολόγος διαπιστώσει πως σε κάποιο κτήριο δεν πληρούνται οι προϋποθέσεις και οι κανονισμοί, πριν την έκδοση του πιστοποιητικού πρέπει από τον ιδιοκτήτη να γίνουν οι κατάλληλες αλλαγές και βελτιώσεις, που θα προτείνει ο ηλεκτρολόγος . Σε διαφορετική περίπτωση αναστέλλεται η έκδοση και μόνο αφότου γίνουν οι παρεμβάσεις θα λάβετε τα πιστοποιητικά ΔΕΗ.
      </p>

      <h3 style={{ fontSize: '1.15rem', marginBottom: '1rem' }}>Οδηγίες υποβολής ΥΔΕ στον ΔΕΔΔΗΕ</h3>
      <p style={{ fontSize: '1.1rem', lineHeight: 1.7, marginBottom: '1.2rem' }}>
        Για την υποβολή του Πιστοποιητικού Ηλεκτρολόγου στον ΔΕΔΔΗΕ υπάρχουν οι παρακάτω επιλογές:
      </p>
      <ul>
        <li>Να υπογράψει ο Ιδιοκτήτης / Χρήστης ψηφιακά την ψηφιακά υπογεγραμμένη ΥΔΕ μέσω του <a href="https://www.gov.gr/ipiresies/polites-kai-kathemerinoteta/psephiaka-eggrapha-gov-gr/psephiake-bebaiose-eggraphou" target="_blank" rel="noopener noreferrer">gov.gr</a> και το Πιστοποιητικό Ηλεκτρολόγου, πλέον ψηφιακά υπογεγραμμένο και από τα δυο μέρη, να αναρτηθεί το ψηφιακά υπογεγραμμένο Πιστοποιητικό Ηλεκτρολόγου μέσω της Πλατφόρμας Αιτημάτων του ΔΕΔΔΗΕ (<a href="https://apps.deddie.gr/ccrWebapp/" target="_blank" rel="noopener noreferrer">https://apps.deddie.gr/ccrWebapp/</a>)</li>
        <li>Να αναρτηθεί το ψηφιακά υπογεγραμμένο Πιστοποιητικό Ηλεκτρολόγου μέσω της Πλατφόρμας Αιτημάτων του ΔΕΔΔΗΕ (<a href="https://apps.deddie.gr/ccrWebapp/" target="_blank" rel="noopener noreferrer">https://apps.deddie.gr/ccrWebapp/</a>) συνοδευόμενο με υπεύθυνη δήλωση του Ιδιοκτήτη / Χρήστη της εγκατάστασης. Η υπεύθυνη δήλωση θα πρέπει να είναι θεωρημένη για το γνήσιο της υπογραφής ψηφιακά μέσω <a href="https://www.gov.gr/ipiresies/polites-kai-kathemerinoteta/psephiaka-eggrapha-gov-gr/psephiake-bebaiose-eggraphou" target="_blank" rel="noopener noreferrer">gov.gr</a></li>
      </ul>
      <p style={{ fontSize: '1.1rem', lineHeight: 1.7, marginBottom: '1.2rem' }}>
        Σε περίπτωση που επιλεγεί από τον Ιδιοκτήτη / Χρήστη η υποβολή της ΥΔΕ στον ΔΕΔΔΗΕ με τη συνοδεία Υπεύθυνης Δήλωσης, το κείμενο αυτής πρέπει να είναι: 
      </p>
      <p style={{ fontSize: '1.1rem', lineHeight: 1.7, marginBottom: '1.2rem' }}>
        “ενημερώθηκα από τον ηλεκτρολόγο εγκαταστάτη …(το ονοματεπώνυμο αυτού που συνέταξε το Πιστοποιητικό)… για την υποχρέωση τακτικού επανελέγχου της ηλεκτρικής εγκατάστασης με αρ. παροχής …(ο αριθμός παροχής της εγκατάστασης)…, έχω παραλάβει αντίγραφο της ΥΔΕ και των συνοδευτικών της εγγράφων που συντάχθηκαν την …(η ημερομηνία έκδοσης της ΥΔΕ)… , και συμφωνώ να υποβληθούν για λογαριασμό μου στην αρμόδια υπηρεσία του ΔΕΔΔΗΕ”
      </p>

      <style>{`
        @media (max-width: 600px) {
          .Eksikonomo {
            padding: 1rem !important;
            margin: 1rem !important;
          }
          .Eksikonomo h2 {
            font-size: 1.4rem !important;
          }
          .Eksikonomo p {
            font-size: 1rem !important;
          }
        }
      `}</style>
    </section>;
}

function Arthro() {
  const navigate = useNavigate();

  return <section className="Arthro" style={{
      maxWidth: 700,
      margin: '2rem auto',
      padding: '1.5rem',
      background: '#fff',
      borderRadius: 12,
      boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
    }}>
      <button 
        onClick={() => navigate(-1)}
        style={{ background: "none", border: "none", fontSize: 36, cursor: "pointer" }}
      >
        ←
      </button>
      <h2 style={{ fontSize: '2rem', marginBottom: '1rem' }}>Υπηρεσίες Άρθρου 30 Ν.4495/2017</h2>
      <p style={{ fontSize: '1.1rem', lineHeight: 1.7, marginBottom: '1.2rem' }}>
        Το Άρθρο 30 Ν.4495/2017 αφορά συγκεκριμένες μικρές εργασίες σε κτίρια, οι οποίες μπορούν να πραγματοποιηθούν χωρίς έκδοση άδειας δόμησης ή Έγκρισης Εργασιών Μικρής Κλίμακας, εφόσον δεν επηρεάζονται η στατική επάρκεια και η γενική μορφή του κτιρίου.
      </p>
      <p style={{ fontSize: '1.1rem', lineHeight: 1.7, marginBottom: '1.2rem' }}>
        Ακολουθεί αναλυτική παρουσίαση των εργασιών που εμπίπτουν στο άρθρο:
      </p>
      <h3 style={{ fontSize: '1.15rem', marginBottom: '1rem' }}>Εσωτερικές διαρρυθμίσεις</h3>
      <ul>
        <li>Αλλαγές στη διαρρύθμιση εσωτερικών χώρων.</li>
        <li>Κατασκευή ή καθαίρεση ελαφρών χωρισμάτων (π.χ. γυψοσανίδες).</li>
        <li>Διαμορφώσεις χωρίς επέμβαση στον φέροντα οργανισμό.</li>
        <li>Τοποθέτηση ψευδοροφών και ελαφρών εσωτερικών κατασκευών.</li>
      </ul>
      <h3 style={{ fontSize: '1.15rem', marginBottom: '1rem' }}>Επισκευές και συντηρήσεις</h3>
      <ul>
        <li>Τοπικές επισκευές επιχρισμάτων (σοβάδες).</li>
        <li>Συντήρηση τοιχοποιίας χωρίς δομικές παρεμβάσεις.</li>
        <li>Επισκευές δαπέδων (πλακάκια, ξύλο, laminate).</li>
        <li>Αποκατάσταση φθορών σε εσωτερικούς χώρους.</li>
      </ul>
      <h3 style={{ fontSize: '1.15rem', marginBottom: '1rem' }}>Κουφώματα και ανοίγματα</h3>
      <ul>
        <li>Αντικατάσταση κουφωμάτων χωρίς αλλαγή διαστάσεων.</li>
        <li>Αντικατάσταση υαλοπινάκων.</li>
        <li>Συντήρηση ή αλλαγή ρολών και μηχανισμών.</li>
        <li>Εργασίες στα υφιστάμενα ανοίγματα.</li>
      </ul>
      <h3 style={{ fontSize: '1.15rem', marginBottom: '1rem' }}>Ηλεκτρομηχανολογικές εργασίες</h3>
      <ul>
        <li>Τοποθέτηση ή αντικατάσταση κλιματιστικών μονάδων.</li>
        <li>Τοποθέτηση ηλιακών θερμοσιφώνων χωρίς στατική επέμβαση.</li>
        <li>Μικρές εργασίες σε ηλεκτρολογικές και υδραυλικές εγκαταστάσεις.</li>
        <li>Αντικατάσταση εξοπλισμού χωρίς τροποποίηση εγκατάστασης.</li>
      </ul>
      <h3 style={{ fontSize: '1.15rem', marginBottom: '1rem' }}>Εργασίες όψεων</h3>
      <ul>
        <li>Επαναχρωματισμός εξωτερικών επιφανειών.</li>
        <li>Τοπικές επισκευές επιχρισμάτων.</li>
        <li>Συντήρηση όψεων χωρίς αλλαγή μορφολογίας.</li>
      </ul>
      <h3 style={{ fontSize: '1.15rem', marginBottom: '1rem' }}>Τοποθέτηση εξοπλισμού</h3>
      <ul>
        <li>Τέντες και συστήματα σκίασης.</li>
        <li>Εξωτερικές μονάδες κλιματισμού.</li>
        <li>Ελαφρές κατασκευές χωρίς θεμελίωση.</li>
      </ul>
      <p style={{ fontSize: '1.1rem', lineHeight: 1.7, marginBottom: '1.2rem' }}>
        👉 Το Άρθρο 30 αφορά μικρές εργασίες συντήρησης και ανακαίνισης, οι οποίες δεν επηρεάζουν τη στατική δομή ή τη μορφή του κτιρίου και μπορούν να πραγματοποιηθούν χωρίς οικοδομική άδεια.
      </p>
      <p style={{ fontSize: '1.1rem', lineHeight: 1.7, marginBottom: '1.2rem' }}>
        👉 Σε περίπτωση που απαιτείται χρήση ικριωμάτων (σκαλωσιές) ή εκτεταμένες εξωτερικές εργασίες, δεν εφαρμόζεται το Άρθρο 30 και απαιτείται Έγκριση Εργασιών Μικρής Κλίμακας (ΕΕΜΚ).
      </p>
      <style>{`
        @media (max-width: 600px) {
          .Eksikonomo {
            padding: 1rem !important;
            margin: 1rem !important;
          }
          .Eksikonomo h2 {
            font-size: 1.4rem !important;
          }
          .Eksikonomo p {
            font-size: 1rem !important;
          }
        }
      `}</style>
    </section>;
}

function Technikos() {
  const navigate = useNavigate();

  return <section className="Technikos" style={{
      maxWidth: 700,
      margin: '2rem auto',
      padding: '1.5rem',
      background: '#fff',
      borderRadius: 12,
      boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
    }}>
      <button 
        onClick={() => navigate(-1)}
        style={{ background: "none", border: "none", fontSize: 36, cursor: "pointer" }}
      >
        ←
      </button>
      <h2 style={{ fontSize: '2rem', marginBottom: '1rem' }}>Τεχνικός Ασφαλείας</h2>
      <p style={{ fontSize: '1.1rem', lineHeight: 1.7, marginBottom: '1.2rem' }}>
        O Τεχνικός Ασφαλείας είναι το Θεσμικό όργανο που έχει προβλεφθεί από την νομοθεσία για την Ασφάλεια και την Υγεία στην Εργασία για την επίβλεψη των συνθηκών εργασίας. Οι αρμοδιότητές του είναι συμβουλευτικές και παρέχει υποδείξεις και συμβουλές στον εργοδότη σχετικά με την υγεία και ασφάλεια των εργαζομένων και την πρόληψη των εργατικών ατυχημάτων.
      </p>
      <h3 style={{ fontSize: '1.15rem', marginBottom: '1rem' }}>Σχετική νομοθεσία</h3>
      <p style={{ fontSize: '1.1rem', lineHeight: 1.7, marginBottom: '1.2rem' }}>
        Άρθρο 504 του Κώδικα εργατικού δικαίου ΠΔ 62/2025 όπως τροποποιήθηκε από το άρθρο 32 του Ν5239/2025 και άρθρα 505 και 510 Κώδικα εργατικού δικαίου όπως ισχύουν.
      </p>
      <p style={{ fontSize: '1.1rem', lineHeight: 1.7, marginBottom: '1.2rem' }}>
        Σύμφωνα με την ισχύουσα νομοθεσία (Ν. 3850/2010), κάθε επιχείρηση που απασχολεί έστω και έναν εργαζόμενο υποχρεούται να χρησιμοποιεί τις υπηρεσίες Τεχνικού Ασφάλειας. Η παρουσία του δεν είναι απλώς μια τυπική νομική υποχρέωση, αλλά ένας καθοριστικός παράγοντας για την προστασία των εργαζομένων και την εύρυθμη λειτουργία της επιχείρησής σας.
      </p>
      <p style={{ fontSize: '1.1rem', lineHeight: 1.7, marginBottom: '1.2rem' }}>
        Παρέχουμε υπηρεσίες Τεχνικού Ασφάλειας σε επιχειρήσεις σε όλο τον νομό αττικής.
      </p>
      <p style={{ fontSize: '1.1rem', lineHeight: 1.7, marginBottom: '1.2rem' }}>
        Στην Κατηγορία Γ (Χαμηλή): Γραφεία, εμπορικά καταστήματα, εστίαση, εκπαιδευτήρια.
      </p>
      <style>{`
        @media (max-width: 600px) {
          .Eksikonomo {
            padding: 1rem !important;
            margin: 1rem !important;
          }
          .Eksikonomo h2 {
            font-size: 1.4rem !important;
          }
          .Eksikonomo p {
            font-size: 1rem !important;
          }
        }
      `}</style>
    </section>;
}

function Poleodomia() {
  const navigate = useNavigate();

  return <section className="Poleodomia" style={{
      maxWidth: 700,
      margin: '2rem auto',
      padding: '1.5rem',
      background: '#fff',
      borderRadius: 12,
      boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
    }}>
      <button 
        onClick={() => navigate(-1)}
        style={{ background: "none", border: "none", fontSize: 36, cursor: "pointer" }}
      >
        ←
      </button>
      <h2 style={{ fontSize: '2rem', marginBottom: '1rem' }}>Αναζήτηση & Ανάκτηση Πολεοδομικού Φακέλου</h2>
      <p style={{ fontSize: '1.1rem', lineHeight: 1.7, marginBottom: '1.2rem' }}>
        Αναλαμβάνουμε εξ ολοκλήρου τη διαδικασία αναζήτησης και ανάκτησης του πολεοδομικού φακέλου από την αρμόδια Υπηρεσία Δόμησης. Η υπηρεσία καλύπτει το σύνολο των ΥΔΟΜ σε όλο τον Νομό Αττικής.
      </p>
      <h3 style={{ fontSize: '1.15rem', marginBottom: '1rem' }}>Τι περιλαμβάνει ο πολεοδομικός φάκελος</h3>
      <ul>
        <li>Στέλεχος οικοδομικής άδειας.</li>
        <li>Αρχιτεκτονικά σχέδια (κατόψεις, τομές, όψεις).</li>
        <li>Τοπογραφικό διάγραμμα.</li>
        <li>Διάγραμμα κάλυψης.</li>
        <li>Στατικά σχέδια και μελέτες (όπου υπάρχουν).</li>
        <li>Ηλεκτρομηχανολογικές μελέτες (όπου υπάρχουν).</li>
      </ul>
      <h3 style={{ fontSize: '1.15rem', marginBottom: '1rem' }}>Πότε χρειάζεται</h3>
      <ul>
        <li>Αγοραπωλησία ή μεταβίβαση ακινήτου.</li>
        <li>Τακτοποίηση αυθαιρέτων.</li>
        <li>Έκδοση Ηλεκτρονικής Ταυτότητας Κτιρίου.</li>
        <li>Συμμετοχή σε επιδοτούμενα προγράμματα (π.χ. «Εξοικονομώ»).</li>
      </ul>
      <h3 style={{ fontSize: '1.15rem', marginBottom: '1rem' }}>Τι χρειαζόμαστε από εσάς</h3>
      <ul>
        <li>Διεύθυνση ακινήτου.</li>
        <li>Αριθμός οικοδομικής άδειας.</li>
      </ul>
      <h3 style={{ fontSize: '1.15rem', marginBottom: '1rem' }}>Παράδοση φακέλου</h3>
      <p style={{ fontSize: '1.1rem', lineHeight: 1.7, marginBottom: '1.2rem' }}>
        Παραλαμβάνετε αντίγραφο του φακέλου σε έντυπη μορφή. Προαιρετικά, τον παρέχουμε και σκαναρισμένο — έτοιμο ψηφιακό αρχείο με όλα τα δικαιολογητικά του ακινήτου σας.
      </p>
      <style>{`
        @media (max-width: 600px) {
          .Eksikonomo {
            padding: 1rem !important;
            margin: 1rem !important;
          }
          .Eksikonomo h2 {
            font-size: 1.4rem !important;
          }
          .Eksikonomo p {
            font-size: 1rem !important;
          }
        }
      `}</style>
    </section>;
}

function Thermansi() {
  const navigate = useNavigate();

  return <section className="Thermansi" style={{
      maxWidth: 700,
      margin: '2rem auto',
      padding: '1.5rem',
      background: '#fff',
      borderRadius: 12,
      boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
    }}>
      <button 
        onClick={() => navigate(-1)}
        style={{ background: "none", border: "none", fontSize: 36, cursor: "pointer" }}
      >
        ←
      </button>
      <h2 style={{ fontSize: '2rem', marginBottom: '1rem' }}>Μελέτη Θέρμανσης</h2>
      <p style={{ fontSize: '1.1rem', lineHeight: 1.7, marginBottom: '1.2rem' }}>
        Η μελέτη θέρμανσης είναι η τεχνική διαδικασία με την οποία υπολογίζεται και σχεδιάζεται το κατάλληλο σύστημα θέρμανσης για έναν χώρο (κατοικία, γραφείο, κατάστημα), ώστε να εξασφαλίζεται άνεση με τη μικρότερη δυνατή κατανάλωση ενέργειας.
      </p>
      <h3 style={{ fontSize: '1.15rem', marginBottom: '1rem' }}>Τι περιλαμβάνει μια μελέτη θέρμανσης</h3>
      <ul>
        <li>Υπολογισμό θερμικών απωλειών: πόση θερμότητα χάνει ο χώρος (τοίχοι, παράθυρα, οροφή κ.λπ.).</li>
        <li>Διαστασιολόγηση σωμάτων θέρμανσης: επιλογή και μέγεθος καλοριφέρ ή ενδοδαπέδιας θέρμανσης.</li>
        <li>Επιλογή συστήματος θέρμανσης:
          <ul>
            <li>Σύστημα με λέβητα (πετρελαίου, φυσικού αερίου, βιομάζας).</li>
            <li>Σύστημα με αντλία θερμότητας (αέρα-νερού, γεωθερμική).</li>
            <li>Σύστημα με ηλεκτρικά σώματα.</li>
          </ul>
        </li>
        <li>Μελέτη σωληνώσεων και κυκλοφορίας νερού.</li>
        <li>Έλεγχο ενεργειακής απόδοσης σύμφωνα με τον ΚΕΝΑΚ.</li>
      </ul>
      <h3 style={{ fontSize: '1.15rem', marginBottom: '1rem' }}>Πότε χρειάζεται</h3>
      <ul>
        <li>Σε νέα οικοδομή (υποχρεωτική).</li>
        <li>Σε ανακαίνιση.</li>
        <li>Σε αλλαγή συστήματος θέρμανσης (π.χ. από πετρέλαιο σε αντλία θερμότητας).</li>
      </ul>
      <h3 style={{ fontSize: '1.15rem', marginBottom: '1rem' }}>Γιατί είναι σημαντική</h3>
      <p style={{ fontSize: '1.1rem', lineHeight: 1.7, marginBottom: '1.2rem' }}>
        Χωρίς σωστή μελέτη:
      </p>
      <ul>
        <li>πληρώνεις περισσότερα σε κατανάλωση.</li>
        <li>δεν θερμαίνονται σωστά οι χώροι.</li>
        <li>φθείρεται πιο γρήγορα ο εξοπλισμός.</li>
      </ul>
      <p style={{ fontSize: '1.1rem', lineHeight: 1.7, marginBottom: '1.2rem' }}>
        Με σωστή μελέτη:
      </p>
      <ul>
        <li>έχεις ομοιόμορφη θερμοκρασία.</li>
        <li>μειώνεις κόστος λειτουργίας.</li>
        <li>βελτιώνεις την ενεργειακή κλάση του ακινήτου.</li>
      </ul>
      <style>{`
        @media (max-width: 600px) {
          .Eksikonomo {
            padding: 1rem !important;
            margin: 1rem !important;
          }
          .Eksikonomo h2 {
            font-size: 1.4rem !important;
          }
          .Eksikonomo p {
            font-size: 1rem !important;
          }
        }
      `}</style>
    </section>;
}

function Eedmk() {
   const navigate = useNavigate();

   const cardColor = "#F7F7F7";

  return (
    <section className="Thermansi" style={{
      maxWidth: 700,
      margin: '2rem auto',
      padding: '1.5rem',
      background: '#fff',
      borderRadius: 12,
      boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
    }}>
    <div style={{ padding: 20 }}>
      <button 
        onClick={() => navigate(-1)}
        style={{ background: "none", border: "none", fontSize: 36, cursor: "pointer" }}
      >
        ←
      </button>
      <h2 style={{ fontSize: '2rem', marginBottom: '1rem' }}>Έγκριση εργασιών δόμησης μικρής κλίμακας (ΕΕΔΜΚ)</h2>
      <p style={{ fontSize: '1.1rem', lineHeight: 1.7, marginBottom: '1.2rem' }}>
       ΕΕΔΜΚ σημαίνει Έγκριση Εργασιών Μικρής Κλίμακας και αφορά τη διαδικασία έγκρισης μικρών κατασκευαστικών επεμβάσεων σε κτίρια χωρίς να απαιτείται πλήρης οικοδομική άδεια.
      </p>
        <div
        style={{
          display: "grid",
          gap: 16,
          gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
          marginTop: 20,
        }}
      >
        <Card 
          title="Αυτόνομη Θέρμανση" 
          text="" 
          onClick={() => navigate("/autonomi")}
          image={autoImg}
          style={{ background: cardColor }}
        />
        <Card 
          title="Θερμοπρόσοψη" 
          text="" 
          onClick={() => navigate("/thermoprosopsi")}
          image={thermoprosopsiImg}
          style={{ background: cardColor }}
        />
        <div />
      </div>
    </div>
  <style>{`
        @media (max-width: 600px) {
          .Eksikonomo {
            padding: 1rem !important;
            margin: 1rem !important;
          }
          .Eksikonomo h2 {
            font-size: 1.4rem !important;
          }
          .Eksikonomo p {
            font-size: 1rem !important;
          }
        }
      `}</style>
    </section>);
}

function Autonomi() {
  const navigate = useNavigate();

  return <section className="Autonomi" style={{
      maxWidth: 700,
      margin: '2rem auto',
      padding: '1.5rem',
      background: '#fff',
      borderRadius: 12,
      boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
    }}>
      <button 
        onClick={() => navigate(-1)}
        style={{ background: "none", border: "none", fontSize: 36, cursor: "pointer" }}
      >
        ←
      </button>
      <h2 style={{ fontSize: '2rem', marginBottom: '1rem' }}>Αυτόνομη Θέρμανση</h2>
      <p style={{ fontSize: '1.1rem', lineHeight: 1.7, marginBottom: '1.2rem' }}>
        Η ΕΕΔΜΚ (Έγκριση Εργασιών Δόμησης Μικρής Κλίμακας) αυτονόμησης είναι η «άδεια» που χρειάζεσαι για να αποκοπείς από την κεντρική θέρμανση και να βάλεις το δικό σου σύστημα (π.χ. λέβητα φυσικού αερίου ή αντλία θερμότητας). Συγκεκριμένα, την εκδίδεις στις εξής περιπτώσεις:
      </p>
      <h3 style={{ fontSize: '1.15rem', marginBottom: '1rem' }}>1. Αυτονόμηση με Φυσικό Αέριο</h3>
      <p style={{ fontSize: '1.1rem', lineHeight: 1.7, marginBottom: '1.2rem' }}>
        Είναι η πιο συνηθισμένη περίπτωση. Τη χρειάζεσαι γιατί:
      </p>
      <ul>
        <li>Θα τοποθετηθεί επίτοιχος λέβητας στο μπαλκόνι ή σε εξωτερικό τοίχο.</li>
        <li>Θα περάσουν εξωτερικές σωληνώσεις (κίτρινες σωλήνες αερίου και σωλήνες νερού) στην όψη της πολυκατοικίας.</li>
        <li>Απαιτείται για την τελική σύνδεση και ενεργοποίηση του μετρητή από την εταιρεία αερίου.</li>
      </ul>
      <h3 style={{ fontSize: '1.15rem', marginBottom: '1rem' }}>2. Εγκατάσταση Αντλίας Θερμότητας</h3>
      <p style={{ fontSize: '1.1rem', lineHeight: 1.7, marginBottom: '1.2rem' }}>
        Αν αποφασίσεις να βάλεις αντλία θερμότητας (που μοιάζει με μεγάλο εξωτερικό κλιματιστικό), χρειάζεσαι την άδεια για:
      </p>
      <ul>
        <li>Την τοποθέτηση της εξωτερικής μονάδας στο μπαλκόνι, την ταράτσα ή τον ακάλυπτο.</li>
        <li>Τις σωληνώσεις που θα συνδέσουν τη μονάδα με το εσωτερικό δίκτυο του σπιτιού.</li>
      </ul>
      <h3 style={{ fontSize: '1.15rem', marginBottom: '1rem' }}>Γιατί η Έγκριση Μικρής Κλίμακας (ΕΕΔΜΚ) είναι Απαραίτητη για την Αυτονόμηση</h3>
      <p style={{ fontSize: '1.1rem', lineHeight: 1.7, marginBottom: '1.2rem' }}>
        Η έκδοση της Έγκρισης Εργασιών Δόμησης Μικρής Κλίμακας δεν είναι μια προαιρετική επιλογή, αλλά η νομική θωράκιση του ιδιοκτήτη για τους εξής 4 λόγους:
      </p>
      <h4 style={{ fontSize: '1rem', marginBottom: '1rem' }}>1. Πλήρης Νομική Κάλυψη</h4>
      <p style={{ fontSize: '1.1rem', lineHeight: 1.7, marginBottom: '1.2rem' }}>
        Νομιμοποιεί τις εργασίες στις όψεις του κτιρίου (τρύπες, σωληνώσεις, τοποθέτηση λέβητα/αντλίας). Χωρίς αυτήν, οι εργασίες θεωρούνται αυθαίρετες, γεγονός που επισύρει βαριά πρόστιμα από την Πολεοδομία σε περίπτωση καταγγελίας και μπλοκάρει τη μελλοντική μεταβίβαση του ακινήτου.
      </p>
      <h4 style={{ fontSize: '1rem', marginBottom: '1rem' }}>2. Παύση Πληρωμής Κοινοχρήστων</h4>
      <p style={{ fontSize: '1.1rem', lineHeight: 1.7, marginBottom: '1.2rem' }}>
        Είναι το μοναδικό επίσημο έγγραφο που αποδεικνύει στη διαχείριση της πολυκατοικίας ότι η αποσύνδεση από την κεντρική θέρμανση έγινε νόμιμα. Με την κατάθεσή της, ο ιδιοκτήτης κατοχυρώνει το δικαίωμα να μην συμμετέχει στις δαπάνες καυσίμου του κεντρικού συστήματος, αποφεύγοντας δικαστικές διαμάχες με τους υπόλοιπους συνιδιοκτήτες.
      </p>
      <h4 style={{ fontSize: '1rem', marginBottom: '1rem' }}>3. Σύνδεση με την ΕΔΑ (Φυσικό Αέριο)</h4>
      <p style={{ fontSize: '1.1rem', lineHeight: 1.7, marginBottom: '1.2rem' }}>
        Για όσους επιλέγουν το φυσικό αέριο, η ΕΔΑ (Εταιρεία Διανομής Αερίου) απαιτεί την ΕΕΔΜΚ στον τεχνικό φάκελο. Χωρίς την άδεια αυτή, η εταιρεία δεν προχωρά στην ενεργοποίηση του μετρητή και στην παροχή αερίου, καθώς η εγκατάσταση θεωρείται μη σύννομη.
      </p>
      <h4 style={{ fontSize: '1rem', marginBottom: '1rem' }}>4. Προϋπόθεση για το «Εξοικονομώ»</h4>
      <p style={{ fontSize: '1.1rem', lineHeight: 1.7, marginBottom: '1.2rem' }}>
        Για τη συμμετοχή σε επιδοτούμενα προγράμματα (όπως το «Εξοικονομώ»), η ΕΕΔΜΚ είναι υποχρεωτικό δικαιολογητικό. Αν οι εργασίες ξεκινήσουν ή ολοκληρωθούν χωρίς την έκδοσή της, ο ιδιοκτήτης τίθεται εκτός προγράμματος και χάνει την επιδότηση.
      </p>
      <p style={{ fontSize: '1.1rem', lineHeight: 1.7, marginBottom: '1.2rem' }}>
        👉 Συμπέρασμα: Η ΕΕΔΜΚ μετατρέπει την αυτονόμηση από μια "ιδιωτική παρέμβαση" σε μια νόμιμη κίνηση, προστατεύοντας τον ιδιοκτήτη από πρόστιμα, διενέξεις και οικονομικές απώλειες.
      </p>

      <style>{`
        @media (max-width: 600px) {
          .Eksikonomo {
            padding: 1rem !important;
            margin: 1rem !important;
          }
          .Eksikonomo h2 {
            font-size: 1.4rem !important;
          }
          .Eksikonomo p {
            font-size: 1rem !important;
          }
        }
      `}</style>
    </section>;
}

function Thermoprosopsi() {
  const navigate = useNavigate();

  return <section className="Thermoprosopsi" style={{
      maxWidth: 700,
      margin: '2rem auto',
      padding: '1.5rem',
      background: '#fff',
      borderRadius: 12,
      boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
    }}>
      <button 
        onClick={() => navigate(-1)}
        style={{ background: "none", border: "none", fontSize: 36, cursor: "pointer" }}
      >
        ←
      </button>
      <h2 style={{ fontSize: '2rem', marginBottom: '1rem' }}>Θερμοπρόσοψη</h2>
      <p style={{ fontSize: '1.1rem', lineHeight: 1.7, marginBottom: '1.2rem' }}>
        Όταν λέμε ΕΕΔΜΚ για θερμοπρόσοψη, εννοούμε την τοποθέτηση εξωτερικής θερμομόνωσης σε όψεις κτιρίου υπό τους εξής όρους:
      </p>
      <ul>
        <li>Δεν επηρεάζεται ο φέροντας οργανισμός του κτιρίου. Δηλαδή δεν κοβονται ή ενισχύονται τοιχοποιίες ή δοκοί.</li>
        <li>Δεν αλλάζει η δόμηση ή το ύψος του κτιρίου. Το πάχος της μόνωσης είναι μικρό και δεν προσμετράται στα πολεοδομικά μεγέθη.</li>
        <li>Δεν τροποποιείται ουσιαστικά η χρήση ή η στατική συμπεριφορά του ακινήτου.</li>
      </ul>
      <p style={{ fontSize: '1.1rem', lineHeight: 1.7, marginBottom: '1.2rem' }}>
        Με απλά λόγια, είναι ο τρόπος να κάνεις ενεργειακή αναβάθμιση (θερμομόνωση) χωρίς να χρειάζεσαι πλήρη οικοδομική άδεια, απλώς με έγκριση μικρής κλίμακας από μηχανικό μέσω της πλατφόρμας e-Άδειες.
      </p>
      <h3 style={{ fontSize: '1.15rem', marginBottom: '1rem' }}>Απαραίτητα Δικαιολογητικά</h3>
      <p style={{ fontSize: '1.1rem', lineHeight: 1.7, marginBottom: '1.2rem' }}>
        Για να κατατεθεί ο φάκελος από τον μηχανικό σου, θα χρειαστούν:
      </p>
      <ul>
        <li>Αίτηση του μηχανικού(ηλεκτρονικά στο σύστημα e-Άδειες).</li>
        <li>Συναίνεση συνιδιοκτητών: Αν πρόκειται για πολυκατοικία, απαιτείται η σύμφωνη γνώμη των συνιδιοκτητών (συνήθως το 50% +1, εκτός αν ο κανονισμός ορίζει διαφορετικά).</li>
        <li>Αντίγραφο Οικοδομικής Άδειας ή παραστατικά νομιμοποίησης (π.χ. τακτοποίηση αυθαιρέτου).</li>
        <li>Φωτογραφίες της υφιστάμενης κατάστασης του κτιρίου.</li>
        <li>Προϋπολογισμός έργου: Για τον υπολογισμό των κρατήσεων και των ενσήμων του ΕΦΚΑ.</li>
      </ul>
      <h3 style={{ fontSize: '1.15rem', marginBottom: '1rem' }}>Βασικά Οφέλη της ΕΕΔΜΚ</h3>
      <ul>
        <li>Νομιμότητα: Αποφεύγεις καταγγελίες από γείτονες και πρόστιμα από την πολεοδομία.</li>
        <li>Ασφάλιση (ΕΦΚΑ): Επιτρέπει τη νόμιμη απασχόληση εργατών και την καταβολή των ενσήμων, κάτι που είναι απαραίτητο για τη μεταβίβαση του ακινήτου μελλοντικά.</li>
        <li>Εξοικονόμηση κατ' Οίκον: Είναι προαπαιτούμενο αν σκοπεύεις να ενταχθείς σε προγράμματα επιδότησης (π.χ. "Εξοικονομώ").</li>
      </ul>
      <h3 style={{ fontSize: '1.15rem', marginBottom: '1rem' }}>Κόστος & Διάρκεια</h3>
      <ul>
        <li>Διάρκεια: Η ΕΕΔΜΚ ισχύει για 12 μήνες, με δυνατότητα παράτασης για άλλους 6 μήνες.</li>
        <li>Χρόνος Έκδοσης: Συνήθως εκδίδεται αυθημερόν ή σε ελάχιστες ημέρες από τη στιγμή που ο μηχανικός ανεβάσει όλα τα έγγραφα στο σύστημα.</li>
        <li>Κόστος: Περιλαμβάνει την αμοιβή του μηχανικού, τα παράβολα και τις κρατήσεις υπέρ Δημοσίου.</li>
      </ul>
      <p style={{ fontSize: '1.1rem', lineHeight: 1.7, marginBottom: '1.2rem' }}>
        👉 Tip: Αν η θερμοπρόσοψη πρόκειται να γίνει σε κτίριο εντός παραδοσιακού οικισμού ή σε διατηρητέο, η διαδικασία είναι πιο σύνθετη καθώς απαιτείται έγκριση από το Συμβούλιο Αρχιτεκτονικής.
      </p>

      <style>{`
        @media (max-width: 600px) {
          .Eksikonomo {
            padding: 1rem !important;
            margin: 1rem !important;
          }
          .Eksikonomo h2 {
            font-size: 1.4rem !important;
          }
          .Eksikonomo p {
            font-size: 1rem !important;
          }
        }
      `}</style>
    </section>;
}

function Footer() {
  return (
    <footer
    className="footer-flex"
  style={{
    padding: 16,
    background: "white",
    color: "black",
    marginTop: "auto",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    minHeight: 120,
    position: "relative",
  }}
>
  {/* Left: Info */}
  <div style={{ textAlign: "left", flex: 1 }}>
    <p style={{ fontSize: "85%", fontWeight: "bold" }}>Μάτα Ηρακλής</p>
    <p style={{ fontSize: "85%", fontWeight: "bold" }}>Πτυχιούχος Μηχανολόγος Μηχανικός Τ.Ε.</p>
    <p style={{ fontSize: "85%", fontWeight: "bold" }}>Μέλος ΤΕΕ (ΑΜ Τ21248)</p>
    <p style={{ fontSize: "85%", fontWeight: "bold" }}>Ενεργειακός Επιθεωρητής Α’ Τάξης (ΑΜ 20854)</p>
    <p style={{ fontSize: "85%", fontWeight: "bold" }}>Ενεργειακός Σύμβουλος</p>
  </div>

  {/* Center: Google Maps Button */}
  <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center" }}>
    <a
      href="https://maps.app.goo.gl/cMVdg4GgASevYyoC8"
      target="_blank"
      rel="noopener noreferrer"
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: 60,
        height: 60,
        borderRadius: "50%",
        background: "green",
        color: "white",
        textDecoration: "none",
        fontWeight: "bold",
        fontSize: 12,
        boxShadow: "0 2px 8px rgba(66,133,244,0.2)",
        margin: "8px 0",
        transition: "background 0.2s",
      }}
      title="Βρείτε μας στο Google Maps"
    >
      <svg width="28" height="28" viewBox="0 0 24 24" fill="white">
        <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5S10.62 6.5 12 6.5s2.5 1.12 2.5 2.5S13.38 11.5 12 11.5z"/>
      </svg>
      <span style={{ display: "none", fontFamily: "Trebuchet MS, Helvetica, sans-serif"}}>Βρείτε μας στο Google Maps</span>
    </a>
    <div style={{ fontSize: "90%", marginTop: 4 , fontFamily: "Trebuchet MS, Helvetica, sans-serif"}}>
      Βρείτε μας στο <a href="https://maps.app.goo.gl/cMVdg4GgASevYyoC8" target="_blank" rel="noopener noreferrer" style={{ color: "#4285F4", textDecoration: "underline" }}>Google Maps</a>
    </div>
  </div>

  {/* Right: Empty for now */}
  <div style={{ flex: 1 }}></div>
  <style>
{`
  @media (max-width: 600px) {
    .footer-flex {
      flex-direction: column !important;
      align-items: stretch !important;
      text-align: center !important;
    }
    .footer-left, .footer-center, .footer-right {
      flex: none !important;
      width: 100% !important;
      margin-bottom: 12px;
    }
    .footer-center {
      margin-bottom: 0;
    }
    .footer-left p {
      text-align: center !important;
    }
  }
`}
</style>
</footer>
  );
}

// function Reviews() {
//   return (
//     <div style={{ padding: 20 }}>
//       <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3143.367589193387!2d23.72184637570475!3d38.01520907192574!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14a1a391e5188223%3A0xe51f69e3b38bfa32!2zzpzOt8-HzrHOvc6_zrvPjM6zzr_PgiDOnM63z4fOsc69zrnOus-Mz4IgIm1pRW5lcmd5Ig!5e0!3m2!1sen!2suk!4v1777124660327!5m2!1sen!2suk"></iframe>
//     </div>
//   );
// }

export default function App() {
  return (
    <Router>
      <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
        <RippleEffect />
        <Navbar />
        <ScrollToTop />

        <div style={{ flex: 1 }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/eksikonomo" element={<Eksikonomo />} />
            <Route path="/energiako" element={<Energiako />} />
            <Route path="/hlektrologos" element={<Hlektrologos />} />
            <Route path="/arthro" element={<Arthro />} />
            <Route path="/technikos" element={<Technikos />} />
            <Route path="/poleodomia" element={<Poleodomia />} />
            <Route path="/thermansi" element={<Thermansi />} />
            <Route path="/eedmk" element={<Eedmk />} />
            <Route path="/autonomi" element={<Autonomi />} />
            <Route path="/thermoprosopsi" element={<Thermoprosopsi />} />
          </Routes>
        </div>

        <Footer />
        <style>{`
          @keyframes ripple {
          to {
          transform: translate(-50%, -50%) scale(15);
          opacity: 0;
            }
          }
    `}</style>
      </div>
    </Router>
  );
}